module.exports = __webpack_public_path__ + "static/1303646379.6a419ac3.jpg";